import { render, staticRenderFns } from "./WorkCentersPage.vue?vue&type=template&id=6d64b8ae&"
import script from "./WorkCentersPage.vue?vue&type=script&lang=js&"
export * from "./WorkCentersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports